<template>
  <div class="modal fade change_pass" id="change_pass_popup" tabindex="-1" role="dialog"
       aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content step1" :class="step === 1 ? '': 'd-none'">
        <button type="button" class="close" @click="closeModal()" data-dismiss="modal"
                aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Wachtwoord wijzigen</h5>
          <h4></h4>
        </div>
        <div class="modal-body change_passw">
          <form>
            <div :class="{'form-group': true, 'error': !isValidCurrentPassword}">
              <input type="password" class="form-control" id="pass1" v-model="currentPassword"
                     name="pass1" placeholder="Huidig wachtwoord" required/>
              <label v-if="!isValidCurrentPassword" class="form-control-label" for="pass1"/>
              <div v-if="!isValidCurrentPassword" class="error_msg">Ongeldig huidig wachtwoord</div>
            </div>
            <div :class="{'form-group': true, 'error': !isValidNewPassword}">
              <input type="password" class="form-control" id="pass2" v-model="newPassword"
                     name="pass2" placeholder="Nieuw wachtwoord" required/>
              <label v-if="!isValidNewPassword" class="form-control-label" for="pass2"/>
              <div v-if="!isValidNewPassword" class="error_msg">Wachtwoord bevat minder dan 8
                tekens
              </div>
            </div>
            <div :class="{'form-group': true, 'error': !isValidConfirmPassword}">
              <input type="password" class="form-control" id="pass3" v-model="confirmPassword"
                     name="pass3" placeholder="Herhaal wachtwoord" required/>
              <label v-if="!isValidConfirmPassword" class="form-control-label" for="pass3"/>
              <div v-if="!isValidConfirmPassword" class="error_msg">Wachtwoorden komen niet
                overeen
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="black_btn step1" @click="submitChangePassword()">
            Bevestigen
          </button>
        </div>
      </div>

      <div class="modal-content step2" :class="step === 2 ? '' : 'd-none'">
        <button type="button" class="close" @click="closeModal()" data-dismiss="modal"
                aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Wachtwoord wijzigen</h5>
          <h4>
            Je wachtwoord is gewijzigd
          </h4>
        </div>
        <div class="modal-body"></div>
        <div class="modal-footer">
          <button type="button" class="black_btn step1" @click="closeModal()">Bevestigen</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import gtm_analytics from "../../common/mixin/gtm_analytics";

export default {
  name: "ChangePassword",
  mixins: [
    gtm_analytics
  ],
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      isValidCurrentPassword: true,
      isValidNewPassword: true,
      isValidConfirmPassword: true,
      step: 1
    }
  },

  mounted() {
    $('#change_pass_popup').modal('show')
    this.pushPopUp('Popup visit', 'Change Password Pop Up')
  },

  computed: {
    ...mapGetters([
      'isChangePasswordModalOpen',
      'getMsisdn',
      'getCompareCustomerPasswordResponse',
      'getChangePasswordResponse'
    ])
  },

  methods: {
    ...mapMutations([
      'updateChangePasswordModal'
    ]),

    ...mapActions([
      'compareCustomerPassword',
      'changePassword'

    ]),

    closeModal() {
      $('#change_pass_popup').modal('hide')
      this.updateChangePasswordModal(false)
    },

    passwordValidationNewPassword() {
      return (/^.{8,}$/.test(this.newPassword))
    },
    passwordValidationCurrentPassword() {
      return (/^.{8,}$/.test(this.currentPassword))
    },
    passwordValidationConfirmPassword() {
      return (/^.{8,}$/.test(this.confirmPassword))
    },

    comparePasswords() {
      return this.newPassword === this.confirmPassword
    },

    resetValidityFlags() {
      this.isValidCurrentPassword = true
      this.isValidNewPassword = true
      this.isValidConfirmPassword = true
    },
    validateForm() {
      if (!this.passwordValidationNewPassword() && !this.passwordValidationCurrentPassword() && !this.passwordValidationConfirmPassword()) {
        this.isValidCurrentPassword = false
        this.isValidNewPassword = false
        this.isValidConfirmPassword = false
        return false
      } else if (!this.passwordValidationNewPassword()) {
        this.isValidNewPassword = false
        return false
      } else if (!this.passwordValidationCurrentPassword()) {
        this.isValidCurrentPassword = false
        return false
      } else {
        if (!this.passwordValidationConfirmPassword()) {
          this.isValidConfirmPassword = false
          return false
        }
      }
      return true
    },

    submitChangePassword() {
      this.resetValidityFlags()

      if (this.validateForm()) {
        this.compareCustomerPassword({
          msisdn: this.getMsisdn,
          password: this.currentPassword
        })
          .then(() => {
            if (this.getCompareCustomerPasswordResponse.failReason === "WRONG_PASSWORD")
              this.isValidCurrentPassword = false

            if (this.getCompareCustomerPasswordResponse.result === "SUCCESS")
              this.compareNewAndConfirmPasswords()
          })
      }
    },

    compareNewAndConfirmPasswords() {
      if (!this.passwordValidationNewPassword()) {
        this.isValidNewPassword = false;
      } else {
        if (!this.comparePasswords()) {
          this.isValidConfirmPassword = false
        } else {
          this.proceedWithChangePassword()
        }
      }
    },

    proceedWithChangePassword() {
      this.changePassword({
        msisdn: this.getMsisdn,
        password: this.newPassword
      }).then(() => {
        if (this.getChangePasswordResponse.result === "SUCCESS")
          this.step = 2
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/ChangePassword.vue